<div class="ppl-container-body">
    <div class="ppl-container-head fake-revert">
        <h1 class="page-title-accessibility">Welcome, {{userData?.first_name}}!</h1>
    </div>
    <div class="ppl-container">

        @if (isPreLaunch) {
            <div class="go-live-centered" role="status" aria-live="polite">
                <div class="go-live-banner">
                    <div class="go-live-banner__header">
                        <div class="go-live-banner__icon">
                            <i class="pi pi-calendar"></i>
                        </div>
                        <div>
                            <h2 class="go-live-banner__headline">Portal Launching Soon</h2>
                            <p class="go-live-banner__tagline">We're planning a big launch — stay tuned!</p>
                        </div>
                    </div>
                    <div class="go-live-banner__body">
                        <p class="go-live-banner__message">
                            The PPL@Home portal will be available soon! You have successfully registered and your
                            user account will be ready on <strong>{{ goLiveDisplayDate }}</strong>. Please contact your
                            Support Broker or Enrollment Specialist if you have questions.
                        </p>
                        <div class="go-live-banner__date-badge" aria-label="Launch date: {{ goLiveDisplayDate }}">
                            <i class="pi pi-clock go-live-banner__date-badge-icon"></i>
                            <span class="go-live-banner__date-label">Launch Date</span>
                            <span class="go-live-banner__date-value">{{ goLiveDisplayDate }}</span>
                        </div>
                    </div>
                </div>
            </div>
        } @else {
            <div class="ppl-content-container">
                @for( displayProgram of displayPrograms ; track displayProgram; let idx = $index ){
                    <ppl-card  [data]="displayProgram" (emitSelectedProgram)="onProgramSelection($event?.program || $event, $event?.event || null)"></ppl-card>
                }@empty {
                    <div> There are no Programs assigned. Please reach out to PPL admin.</div>
                }
            </div>
        }
    </div>

    <p-popover #rolePopover [dismissable]="true">
        <div class="role-popover">
            <div class="role-popover__header">
                <h3 class="role-popover__title">Select Your Profile</h3>
            </div>
            
            <p class="role-popover__subtitle">
                Choose your profile for <strong>{{ pendingSelection?.program?.program_name }}</strong>
            </p>

            <div class="role-list">
                @for (role of pendingSelection?.roles; track $index) {
                    <div 
                        class="role-item" 
                        tabindex="0"
                        [attr.aria-label]="'Select profile ' + role.role_name"
                        (click)="onRoleSelection(role)"
                        (keydown.enter)="onRoleSelection(role)"
                        (keydown.space)="onRoleSelection(role); $event.preventDefault()">
                        <div class="role-item__icon">
                            <i class="pi pi-user"></i>
                        </div>
                        <span class="role-item__name">{{ getDisplayRoleName(role) }}</span>
                        <i class="pi pi-chevron-right role-item__arrow"></i>
                    </div>
                }
            </div>
        </div>
    </p-popover>
</div>